import * as React from 'react';
import { PlayCircleFilled } from '@ant-design/icons';
import { NoteMediaItem } from '../../utils/NoteMediaUtils';

interface NotesMediaVideoTileProps {
	item: NoteMediaItem;
	/** The square tile shell, plus sizing from the container. */
	className?: string;
	onOpen: (item: NoteMediaItem) => void;
}

// Appending `#t=0.1` makes the browser seek to — and paint — the first frame, so the tile shows a
// real poster. Without the fragment the element stays a blank box until playback starts.
const getPosterSrc = (url: string): string => `${url}#t=0.1`;

/**
 * One video in the media grid: its first frame as a poster with a play badge. Videos sit in the
 * same grid as the photos but open in their own player rather than the photo lightbox.
 */
const NotesMediaVideoTile: React.FC<NotesMediaVideoTileProps> = ({
	item,
	className = '',
	onOpen,
}) => {
	const handleClick = () => onOpen(item);

	return (
		<div className={`cursor-pointer bg-black ${className}`} onClick={handleClick}>
			<video
				className="absolute inset-0 h-full w-full object-cover"
				src={getPosterSrc(item.url)}
				preload="metadata"
				muted
				playsInline
			/>
			<span className="pointer-events-none absolute inset-0 flex items-center justify-center text-[28px] leading-none text-white/90">
				<PlayCircleFilled />
			</span>
		</div>
	);
};

export default NotesMediaVideoTile;
